import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/download.css";
import download1 from "../images/download1.jpg";

const DownloadForm = () => {
  const initialFormData = {
    name: "",
    company: "",
    email: "",
    phone: "",
    industry: "",
    lineIntroduction: "",
    introductionTiming: "",
    privacyAgreement: false,
  };
  const [formData, setFormData] = useState(initialFormData);
  const [submitted, setSubmitted] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://fte30k7x40.execute-api.ap-northeast-1.amazonaws.com/prod/download",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setSubmitted(true);
        setMessage("送信完了しました。<br />お申し込みありがとうございます。");
        setFormData(initialFormData);
      } else {
        setSubmitted(true);
        setMessage("送信に失敗しました。お手数ですが、再度お試しください。");
      }
    } catch (error) {
      console.error("送信エラー:", error);
      setSubmitted(true);
      setMessage(
        "エラーが発生しました。ネットワークをご確認のうえ、再度お試しください。"
      );
    }
  };

  return (
    <div className="download-section">
      <h2 className="download-title">RAG on クラウド紹介資料ダウンロード</h2>

      <div className="download-form-container">
        <div className="left-section">
          <img src={download1} alt="Download" className="download-image" />

          <div className="recommendation-section">
            <h3>このような方におすすめ</h3>
            <ul>
              <li>・生成AIやRAGの導入を検討している方</li>
              <li>・自社の業務にAIをどう活用できるか知りたい方</li>
              <li>・社内ナレッジの活用や業務効率化に課題を感じている方</li>
              <li>・AIチャットボットや自動化の導入事例に興味のある方</li>
            </ul>
          </div>

          <p className="download-instruction">
            フォーム送信完了後、ご入力いただいた<br></br>
            メールアドレスに資料をお送りいたします。
          </p>
        </div>

        <div className="form-container">
          <form onSubmit={handleSubmit}>
            <label className="form-label">
              <div className="label-with-required">
                担当者名<span className="required">必須</span>
              </div>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
              />
            </label>

            <label className="form-label">
              <div className="label-with-required">
                会社名<span className="required">必須</span>
              </div>
              <input
                type="text"
                name="company"
                value={formData.company}
                onChange={handleChange}
                required
                className="form-input"
              />
            </label>

            <label className="form-label">
              <div className="label-with-required">
                メールアドレス<span className="required">必須</span>
              </div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </label>

            <label className="form-label">
              <div className="label-with-required">
                電話番号<span className="required">必須</span>
              </div>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                className="form-input"
              />
            </label>

            <label className="form-label">
              <div className="label-with-required">
                業種<span className="required">必須</span>
              </div>
              <input
                type="text"
                name="industry"
                value={formData.industry}
                onChange={handleChange}
                required
                className="form-input"
              />
            </label>

            <label className="form-label">
              <div className="label-with-required">
                <span>すでに生成AIやRAGを導入していますか？</span>
                <span className="required">必須</span>
              </div>
              <div className="radio-group">
                <div className="radio-container">
                  <input
                    type="radio"
                    name="lineIntroduction"
                    value="はい"
                    checked={formData.lineIntroduction === "はい"}
                    onChange={handleChange}
                    required
                  />
                  <label className="radio-check" htmlFor="lineYes">
                    はい
                  </label>
                </div>
                <div className="radio-container">
                  <input
                    type="radio"
                    name="lineIntroduction"
                    value="いいえ"
                    checked={formData.lineIntroduction === "いいえ"}
                    onChange={handleChange}
                    required
                  />
                  <label className="radio-check" htmlFor="lineNo">
                    いいえ
                  </label>
                </div>
              </div>
            </label>

            {formData.lineIntroduction === "いいえ" && (
              <label className="form-label">
                <div className="label-with-required">
                  <span>生成AIやRAGの導入を検討していますか？</span>
                  <span className="required">必須</span>
                </div>
                <div className="radio-group">
                  <div className="radio-container">
                    <input
                      type="radio"
                      name="introductionTiming"
                      value="すぐに導入したい"
                      checked={
                        formData.introductionTiming === "すぐに導入したい"
                      }
                      onChange={handleChange}
                      required
                    />
                    <label className="radio-check" htmlFor="timingNow">
                      すぐに導入したい
                    </label>
                  </div>
                  <div className="radio-container">
                    <input
                      type="radio"
                      name="introductionTiming"
                      value="すぐではないが導入したい"
                      checked={
                        formData.introductionTiming ===
                        "すぐではないが導入したい"
                      }
                      onChange={handleChange}
                      required
                    />
                    <label className="radio-check" htmlFor="timingLater">
                      すぐではないが導入したい
                    </label>
                  </div>
                  <div className="radio-container">
                    <input
                      type="radio"
                      name="introductionTiming"
                      value="未定"
                      checked={formData.introductionTiming === "未定"}
                      onChange={handleChange}
                      required
                    />
                    <label className="radio-check" htmlFor="timingUndecided">
                      未定
                    </label>
                  </div>
                </div>
              </label>
            )}

            <label className="form-label">
              <div className="form-label checkbox-container">
                <input
                  type="checkbox"
                  name="privacyAgreement"
                  checked={formData.privacyAgreement}
                  onChange={handleChange}
                  required
                />
                <span>
                  弊社の
                  <Link
                    to="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    プライバシーポリシー
                  </Link>
                  に同意する
                </span>
              </div>
            </label>

            <div className="button-container">
              <button className="download-button">
                資料をダウンロードする
              </button>
            </div>
            {submitted && (
              <div
                className="download-success-message"
                dangerouslySetInnerHTML={{ __html: message }}
              />
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default DownloadForm;
